<template>
    <div class="connectionContainer">
        <div class="connectionHeader">
            <div class="modal_title"> 広告媒体設定</div>
        </div>
        <div class="connectionContents">
            <div class="modal_body">
                <div class="modal_form">
                    <template v-if="!createMode">
                        <h3><span>【{{ this.media.id }}】</span>{{ this.media.name }}</h3>
                    </template>
                    <div class="modal_input">
                        <label>広告媒体名</label>
                        <input type="text" placeholder="広告媒体名" v-model="media.name">
                    </div>
                </div>
                <div class="modal_submit">
                    <template v-if="createMode">
                        <Button width="100px" @click="createMedia">追加</Button>
                    </template>
                    <template v-else>
                        <Button width="100px" @click="updateMedia">更新</Button>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        createMode: Boolean,
        mediaId: Number,
    },
    data() {
        return {
            media: {}
        }
    },
    mounted: function () {
        if (this.mediaId !== null) {
            this.getMedia();
        }
    },
    methods: {
        //選択されたメディア取得
        getMedia: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/media/root/" + this.mediaId)
                .then((res) => {
                    this.media = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },


        //追加
        createMedia: function () {
            this.$store.dispatch("loading", true);
            let data = {
                name: this.media.name,
            };

            //root_mediaに追加
            this.axios.post("/api/media/root/", data)
                .then((res) => {

                    //name: 入力された名称（root_mediaと同じ名前）
                    //is_other_medium: 1（外部）固定
                    //root_medium_id: root_mediaに今追加したとき採番されたID
                    data = {
                        name: this.media.name,
                        is_other_medium: 1,
                        root_medium_id: res.data
                    }

                    //mediaに追加
                    this.axios.post("/api/media/", data)
                        .then(() => {
                            this.modalClose();
                        }).catch(() => {
                        }).finally(() => {
                            this.$store.dispatch("loading", false);
                        })

                }).catch(() => {
                    this.$store.dispatch("loading", false);
                }).finally(() => {
                });
        },


        //更新
        updateMedia: function () {
            this.$store.dispatch("loading", true);
            const data = {
                name: this.media.name,
            };

            //root_mediaを更新
            this.axios.put("/api/media/root/" + this.mediaId, data)
                .then(() => {

                    //mediaを更新（名称のみ）
                    this.axios.put("/api/media/" + this.mediaId, data)
                        .then(() => {
                            this.modalClose();
                        }).catch(() => {
                        }).finally(() => {
                            this.$store.dispatch("loading", false);
                        })

                }).catch(() => {
                    this.$store.dispatch("loading", false);
                }).finally(() => {
                });
        },


        //データを再取得してこのモーダルを閉じる
        //親メソッド（MediaSetting.vue）で実行
        modalClose() {
            this.$emit('modalClosed');
            this.$store.dispatch("successful", false);
        }
    }
}
</script>


<style scoped lang="sass">
.connectionContainer
    height: 100%
    width: 100%
    margin: 0
    padding: 10px
    display: inline-grid
    grid-template-rows: 40px 1fr 40px
    grid-row-gap: 10px
    .connectionHeader
        display: flex
        align-items: center
        font-size: 1.5rem
        justify-content: center
        .modal_title
            font-size: 1.8rem
    .connectionContents
        display: inline-grid
        overflow: auto
        .modal_form
            padding: 32px
            h3
                font-size: 1.6rem
                font-weight: 700
                margin-bottom: 24px
            p
                font-size: 1.4rem
                color: #777
            .modal_input
                margin-bottom: 24px
                display: flex
                justify-content: start
                align-items: center
                label
                    font-size: 1.4rem
                    width: 30%

                input
                    border: 1px solid $grayColor
                    width: 70%
                    padding: 10px
                    text-align: left
                    width: 100%
                    &:focus
                        outline: 2px solid $mainColor
                select
                    padding: 10px
                    width: 100%
        .modal_submit
            display: flex
            justify-content: center
    .modal_delete
        padding: 24px
        p
            font-size: 1.6rem
        .delete_btns
            margin-top: 40px
            display: flex
            justify-content: space-evenly
    .connectionFooter
        display: flex
        justify-content: start
</style>
